const options = (isTable = false) =>{
    const data = 
    [
      { name: 'imgLink', label: 'QR', type: 'qr' },

      { name: 'title', label: 'Titulok', type: 'text' },
      { name: 'link', label: 'Link', type: 'text',disabled:true },

      { name: 'createdAt', label: 'Vytvorené', type: 'date', default: new Date(),disabled:true },

      // { name: 'delete', hidden: true, label: 'Delete', type: 'checkbox', default: false }
      ];
    return !isTable ? data.filter(e => e.label) : data.filter(e => !e.hidden).map(e => ({Header: e.label ? e.label : e.labelname ,accessor: e.name,type: e.type, populate: e.populate}));
}
export default options;

